import React, { useEffect, useState } from "react";
import SingleCard from "./SingleCard";

const CardGroup = () => {
  const [cardsInfo, setCardsInfo] = useState([]);

  useEffect(() => {
    const url = `https://my-json-server.typicode.com/Codeinwp/front-end-internship-api/posts`;
    fetch(url)
      .then((res) => res.json())
      .then((infos) => setCardsInfo(infos));
  }, []);
  return (
    <div className="card-group">
      {cardsInfo.map((card) => (
        <SingleCard key={card.id} card={card} />
      ))}
    </div>
  );
};

export default CardGroup;
